import { ABOUT_SERVICE } from 'shared/constants/aboutService';
import { Title } from '../Title';
import * as style from './AboutServiceBanner.css';
import { TAboutService } from 'shared/types/aboutService';
import clsx from 'clsx';
import { Responsive, TDeviceType, TooltipMobile } from '@cian/ui-kit';

interface IAboutServiceBannerProps {
  activeItem: TAboutService;
  onChangeActiveItem: (newValue: TAboutService) => void;
  activeNotice?: boolean;
  onChangeActiveNotice: VoidFunction;
  device: TDeviceType;
}

export const AboutServiceBanner: React.FC<IAboutServiceBannerProps> = ({
  activeItem,
  onChangeActiveItem,
  activeNotice,
  onChangeActiveNotice,
  device,
}) => {
  const { id, imageClass, description, notice } = activeItem;

  return (
    <div
      id="aboutProduct"
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title']}>
        <Title>Циан х ПИК-Аренда</Title>
      </div>
      <div className={clsx(style['banner'], style[imageClass])}>
        <div className={style['items']}>
          {ABOUT_SERVICE.map(item => (
            <div
              key={item.id}
              onClick={() => onChangeActiveItem(item)}
              className={clsx(style['item'], id === item.id && style['active'])}
            >
              {item.title}
            </div>
          ))}
        </div>
        <div className={style['description-container']}>
          <div className={style['description']} key={id}>
            {description.map((item, index) => (
              <div className={clsx(style['text'], item.imageClass && style['list'])} key={index}>
                {item.imageClass && <div className={clsx(style['text-image'], style[item.imageClass])} />}
                {item.text}
                {notice && (
                  <>
                    <Responsive phone>
                      <TooltipMobile title={notice}>
                        <span className={style['notice']} />
                      </TooltipMobile>
                    </Responsive>
                    <Responsive desktop tablet>
                      <span onClick={onChangeActiveNotice} data-name="Notice" className={style['notice']} />
                    </Responsive>
                  </>
                )}
              </div>
            ))}
          </div>
          {activeNotice && (
            <div className={style['notice-container']}>
              В Москве и МО, Санкт-Петербурге и ЛО. «
              <a href="https://m-p-a.ru/nedvizhimost.html" target="_blank" rel="noreferrer">
                Михайлов и Партнёры. Аналитика
              </a>
              » — «
              <a href="https://m-p-a.ru/nedvizhimost.html" target="_blank" rel="noreferrer">
                Отношение целевой аудитории к инвестициям в недвижимость
              </a>
              », выборка 1 112 респондентов, которые планируют покупку недвижимости в ближайший год или совершили
              покупку недвижимости в 2022-2023 гг., январь 2024
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
